export var CLASSNAME_PREFIX = 'av-summary';
export var TRANSLATION_CONTEXT = 'accountverification';
//# sourceMappingURL=componentConfig.js.map